import React from 'react';
import { css } from 'react-emotion';
import { components, colors, fonts } from '@peachjar/components';

import CsvImage from './CsvImage.svg';

const { silver, prussian } = colors;
const { ProximaNova, ProximaNovaSemiBold } = fonts;
const { Buttons } = components;

const { ButtonPrimaryLarge, ButtonSecondaryLarge } = Buttons;

const CSV_BOX_HEIGHT_BEFORE = '487px';
const CSV_BOX_HEIGHT_AFTER = '387px';

const renderUploadButton = (primary = true, disabled = false) => {
  const styles = {
    button: css`
      font-family: ${ProximaNova};
    `,
  };
  if (primary) {
    return (
      <ButtonPrimaryLarge
        data-testid="click-uploadcsv"
        data-button-type="primary"
        className={styles.button}
        disabled={disabled}
      >
        Upload CSV File
      </ButtonPrimaryLarge>
    );
  }

  return (
    <ButtonSecondaryLarge
      data-testid="click-uploadcsv"
      data-button-type="secondary"
      className={styles.button}
      disabled={disabled}
    >
      Upload CSV File
    </ButtonSecondaryLarge>
  );
};

const UploadCSVContainer = ({
  showUploadMessage,
  enableUploadButton,
  onChangeHandler,
}) => (
  <div
    className={`row flex-column align-items-center justify-content-center ${
      styles.fileUploadWrapper
    }`}
    style={{
      height: showUploadMessage ? CSV_BOX_HEIGHT_AFTER : CSV_BOX_HEIGHT_BEFORE,
    }}
  >
    {!showUploadMessage ? (
      <CsvImage />
    ) : (
      <div className={styles.fileUploadMessage}>
        Upload a new file to replace the current one
      </div>
    )}
    <div className={styles.fileUploadButtonWrapper}>
      {showUploadMessage
        ? renderUploadButton(false, !enableUploadButton)
        : renderUploadButton(true, !enableUploadButton)}
      <input
        disabled={!enableUploadButton}
        type="file"
        name="csvFile"
        accept="text/csv"
        onChange={onChangeHandler}
        className={styles.fileUploadButton}
      />
    </div>
  </div>
);

export default UploadCSVContainer;

export { renderUploadButton };

const styles = {
  button: css`
    font-family: ${ProximaNova};
  `,
  fileUploadMessage: css`
    color: ${prussian};
    font-family: ${ProximaNovaSemiBold};
    font-size: 16px;
    font-weight: bold;
  `,
  fileUploadButtonWrapper: css`
    position: relative;
    height: 64px;
    width: 203px;
    margin-top: 24px;
    overflow: hidden;
  `,
  fileUploadButton: css`
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  `,
  fileUploadWrapper: css`
    width: 920px;
    background-color: #fafafa;
    border: 2px dashed ${silver};
    border-radius: 6px;
    margin: 1rem 0 0 0 !important;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/components/UploadCSVContainer.jsx